import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { useGetOrganizations } from '@/hooks/useGetOrganizations';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';

const { useFormInstance } = Form;

export function OrganizationFormItem(): JSX.Element {
	const form = useFormInstance();
	const { isLoading, data: organizations = [] } = useGetOrganizations();

	function handleOnChange(): void {
		form.resetFields(['company_id', 'sector_id', 'line_id', 'workstation_id']);
	}

	const isDisabled = !organizations.length;

	return (
		<FormItemWrapper name="organization_id" label={I18n.get('Company')} labelCol={{ span: 24 }}>
			<SelectOptions
				allowClear
				options={organizations}
				loading={isLoading}
				disabled={isDisabled}
				onChange={handleOnChange}
				placeholder={I18n.get('Company')}
			/>
		</FormItemWrapper>
	);
}
